var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 7.62905H15.3V7.6H9V10.4H12.956C12.3789 12.0299 10.828 13.2 9 13.2C6.68055 13.2 4.8 11.3194 4.8 9C4.8 6.68055 6.68055 4.8 9 4.8C10.0706 4.8 11.0447 5.2039 11.7863 5.86365L13.7663 3.8837C12.5161 2.71855 10.8438 2 9 2C5.13425 2 2 5.13425 2 9C2 12.8657 5.13425 16 9 16C12.8657 16 16 12.8657 16 9C16 8.53065 15.9517 8.0725 15.8638 7.62905Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81641 5.74185L5.11626 7.4285C5.73855 5.8878 7.24565 4.8 9.0093 4.8C10.08 4.8 11.054 5.2039 11.7957 5.86365L13.7756 3.8837C12.5254 2.71855 10.8531 2 9.0093 2C6.3206 2 3.98891 3.51795 2.81641 5.74185Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99737 16C10.8055 16 12.4484 15.3081 13.6905 14.1828L11.524 12.3495C10.8212 12.8819 9.94762 13.2 8.99737 13.2C7.17667 13.2 5.63072 12.0391 5.04832 10.4189L2.76562 12.1777C3.92412 14.4446 6.27682 16 8.99737 16Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 7.62903H15.3V7.59998H9V10.4H12.956C12.6788 11.1829 12.1752 11.8581 11.5256 12.3498L11.5266 12.3491L13.6931 14.1824C13.5398 14.3217 16 12.5 16 8.99998C16 8.53063 15.9517 8.07248 15.8638 7.62903Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7915afe0abcd19ffe99b2e87323a4fef.svg";
export { ForwardRef as ReactComponent };